import React from 'react';
import PropTypes from 'prop-types';
import FormInput from './FormInput';
import FormCheckbox from './FormCheckbox';
import FormSelect from './FormSelect';
import InputMasked from './FormInputMasked';

const Form = ({ children, ...props }) => <form {...props}>{children}</form>;

Form.propTypes = {
  children: PropTypes.node,
};

Form.InputMasked = InputMasked;
Form.Input = FormInput;
Form.Checkbox = FormCheckbox;
Form.Select = FormSelect;

export default Form;
